import React, { useState } from 'react';
import {
  Alert,
  DropdownSelect,
  Loading,
} from '../../../../../../../components';
import { useGetPanelSummaryTable } from '../../../../../graphql';
import { PANEL_FORM_DIALOG_TEXT } from '../../../../../lang';
import { type PANEL_RESULT } from '../options';
import { type PanelSummaryTableProps } from './PanelSummaryTable';

export type PartnerSummaryTableData = {
  partnerUniversity: string;
  partnerUniversityName: string;
  total: number;
  filtered: number;
  studentshipYears?: number;
};

const PanelPartnerSummaryTable: React.FunctionComponent<
  PanelSummaryTableProps
> = (props: PanelSummaryTableProps) => {
  const { panelResultOptions, panelId } = props;
  const [selectedSummaryResult, setSelectedSummaryResult] = useState<
    PANEL_RESULT[]
  >([]);
  const summaryFilter = !selectedSummaryResult.length
    ? {}
    : {
        panelResults: {
          all: selectedSummaryResult,
        },
      };

  const {
    partnerSummary: panelSummaryData,
    loading,
    error,
  } = useGetPanelSummaryTable(panelId, summaryFilter);

  const handleChangeSummaryResult = (result: PANEL_RESULT[]): void => {
    setSelectedSummaryResult(result);
  };

  if (error) {
    return (
      <Alert
        openAlert
        setOpenAlert={() => {}}
        alertDetails={{
          alertContent: `Error Occurs.` + (error as Error)?.message,
          alertType: 'error',
        }}
      />
    );
  }

  return (
    <div className="w-[1100px] p-[16px] overflow-y-auto">
      <div className="flex flex-wrap gap-[24px] items-center mb-[40px]">
        <p className="font-bold text-[#951d1d] text-[20px]">
          {PANEL_FORM_DIALOG_TEXT.PARTNER_SUMMARY_TABLE}
        </p>
        <div className="w-[500px]">
          <DropdownSelect
            options={panelResultOptions}
            size="small"
            InputLabelProps={{ shrink: true }}
            value={selectedSummaryResult}
            label={'Result'}
            maxWidth="800px"
            onChange={selectedValue => {
              handleChangeSummaryResult(selectedValue as PANEL_RESULT[]);
            }}
          />
        </div>
      </div>

      <div>
        <div className="bg-[#951d1d] grid grid-cols-[2fr,1fr,1fr,1fr] text-white text-[16px]">
          {[
            'Partner University',
            'Total Application',
            'Studentship Years Given',
            'Number Filtered by Result',
          ].map((item, index) => (
            <div className="p-[10px] text-left font-semibold" key={index}>
              {item}
            </div>
          ))}
        </div>

        {loading ? (
          <Loading />
        ) : (
          <div className="h-[76vh] overflow-y-auto">
            <div className="border-b-[2px] border-b-[#E0E0E0]">
              {panelSummaryData.map((item, index) => (
                <div
                  key={index}
                  className="grid grid-cols-[2fr,1fr,1fr,1fr] py-[4px] border-t-[2px] border-t-[#E0E0E0] hover:bg-[#f0f0f0]"
                >
                  <p className="px-[10px] text-[#951d1d]">
                    {item.partnerUniversityName}
                  </p>
                  <p className="px-[20px]">{item.total}</p>
                  <p className="px-[20px]">{item.studentshipYears}</p>
                  <p className="px-[20px]">{item.filtered}</p>
                </div>
              ))}
            </div>
          </div>
        )}
      </div>
    </div>
  );
};
const MemoizedPanelPartnerSummaryTable = React.memo(PanelPartnerSummaryTable);
export { MemoizedPanelPartnerSummaryTable };
